import { render } from "./PageFeatures.vue?vue&type=template&id=299b46a0"
import script from "./PageFeatures.vue?vue&type=script&lang=js"
export * from "./PageFeatures.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__